// extracted by mini-css-extract-plugin
export default {"container":"CreateCouponsModal_container__F159l"};